const companyLogo:{[key: string]: any } = {
    "bataan": require("./bataan.svg").default,
    "taneko": require("./taneko.svg").default,
}

export {companyLogo};